import { observable, action, flow, computed } from 'mobx';
import Util from 'utils';
import dayjs from 'dayjs';
import Config from 'config/Config';
import Stores from 'config/Stores';
import { Toast } from 'antd-mobile';
import Serv from './AchievementServ';

class AchievementMod {
  // 期数列表
  @observable periodList = [];

  // 个人业绩当前选择的期数
  @observable personalPeriod = '';

  // 个人业绩数据
  @observable personalAchieve = {};

  // 复消查询期数列表
  @observable deconPeriodList = [];
  @observable periodList = [];

  // 复消查询当前选择的期数
  @observable deconPeriod = '';

  // 会员姓名
  @observable memberName = '';

  // 是否合格
  @observable pass = false;

  // 区域业绩表期数
  @observable regionPeriod = '';

  // 区域业绩
  @observable regionAchieveList = [];

  // 零售区域业绩表期数
  @observable retailRegionPeriod = '';

  // 零售区域业绩
  @observable retailRegionAchieveList = [];

  // 我的销售费(全部)
  @observable allCommission = [];

  // 我的销售费(失败)(不和“成功”一样从“全部”里面过滤，单独调接口请求回来)
  @observable failCommission = [];

  // 当前查看的销售费详情
  @observable commissionDetail = {};

  // 用户是否可以申请补发销售费
  @observable commissionSent = {};

  // 续约数据
  @observable renewalData = {};

  // 是否展示复消查询结果弹窗
  @observable isShowDeconvolutionModal = false;

  @observable dataList = [];

  @observable isRequest = false;

  // 发放成功的销售费（直接在"全部"里面过滤出成功的）
  @computed
  get successCommission() {
    return this.allCommission; // 此处的全部数据，已经是成功的数据
    // return this.allCommission.filter(item => item.isSucced == 0);
  }

  // // 发放失败的销售费
  // @computed
  // get failCommission() {
  //   return this.allCommission.filter(item => item.isSucced != 0);
  // }

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 查询期数列表
   */
  getPeriodList = flow(function* (settleStatus) {
    try {
      const { data } = yield Serv.getPeriodList({ settleStatus: 0 });
      this.periodList = data.map((item) => ({
        label: `${item.period}期 ${dayjs(item.endTime).format('YYYY-MM-DD')}`,
        value: item
      }));
    } catch (error) {}
  });

  /**
   * 查询期数列表
   */
  getDeconPeriodList = flow(function* () {
    try {
      const { data } = yield Serv.getDeconPeriodList({ recentPeriod: 4 });
      this.periodList = data || [];
      this.deconPeriodList = data.map((item) => ({
        label: `${item.period}期 ${dayjs(item.endTime).format('YYYY-MM-DD')}`,
        value: item
      }));
      return this.deconPeriodList;
    } catch (error) {}
  });

  /**
   * 查询复消结果
   */
  getQueryFxPassOrNot = flow(function* (cardCode) {
    try {
      const period = this.periodList.map((item) => item.period);
      const { data } = yield Serv.getQueryFxPassOrNot({ cardCode, period });
      if (data) {
        this.dataList = data || [];
        this.isRequest = true;
      } else {
        this.dataList = [];
        this.isRequest = true;
      }
    } catch (error) {
      this.dataList = [];
    }
  });

  /**
   * 查询个人业绩
   */
  getPersonalAchieve = flow(function* () {
    try {
      const { data } = yield Serv.getPersonalAchieve({
        cardCode: Stores.AppMod.userInfo.cardCode,
        period: this.personalPeriod.period
      });
      if (data) {
        data.yuexgfs3 = Math.round(parseInt(data.yuexgfs2) * 0.2);
      }
      this.personalAchieve = data || {};
    } catch (error) {}
  });

  /**
   * 查询区域业绩
   */
  getRegionAchieve = flow(function* () {
    try {
      const { data } = yield Serv.getRegionAchieve({
        cardCode: Stores.AppMod.userInfo.cardCode,
        period: this.regionPeriod.period
      });
      this.regionAchieveList = data || [];
    } catch (error) {}
  });

  /**
   * 查询零售区域业绩
   */
  getRetailRegionAchieve = flow(function* () {
    try {
      const { data } = yield Serv.getRetailRegionAchieve({
        cardCode: Stores.AppMod.userInfo.cardCode,
        period: this.retailRegionPeriod.period
      });
      this.retailRegionAchieveList = data || [];
    } catch (error) {}
  });

  /**
   * 我的销售费
   * @param {Number} filter - 销售费发放状态，0-发放成功，1-发放失败 2-全部
   */
  getCommission = flow(function* (filter) {
    try {
      const { data } = yield Serv.getCommission(filter);
      data && (this.allCommission = data);
    } catch (error) {}
  });

  /**
   * 销售费发放失败列表
   */
  getCommissionFail = flow(function* () {
    try {
      const { data } = yield Serv.getCommissionFail();
      data && (this.failCommission = data);
    } catch (error) {}
  });

  /**
   * 查询用户是否可以申请补发销售费
   */
  getCommissionSent = flow(function* () {
    try {
      const { data } = yield Serv.getCommissionSent();
      this.commissionSent = data || {};
    } catch (error) {}
  });

  /**
   * 提交补发销售费申请
   */
  applyCommission = flow(function* () {
    let { commissionSent } = this;
    commissionSent.isSent = 'False';
    this.commissionSent = commissionSent;
    try {
      const { bank, bankCard, bankName } = this.commissionSent;
      const params = {
        bank,
        bankcard: bankCard,
        bankname: bankName,
        bh: Stores.AppMod.userInfo.cardCode
      };
      const { data, resultCode, resultMsg } = yield Serv.applyCommission(params);
      if (resultCode != 0) {
        Toast.fail(resultMsg, 1, () => {
          if (resultCode == '10002')
            window.app.routerGoTo({
              pathname: '/member/wallet/bankCard',
              state: {
                skipUrl: '/promote/achievement/commission/detail',
                oldState: this.commissionDetail
              }
            });
        });
        return;
      }
      Toast.success('申请补发成功', 1, () => {
        window.app.router.goBack();
      });
    } catch (error) {}
  });

  /**
   * 查询会员续约
   */
  getMemberRenewal = flow(function* () {
    try {
      const { data } = yield Serv.getMemberRenewal();
      this.renewalData = data || {};
    } catch (error) {}
  });
}
const achievementMod = new AchievementMod();
export default achievementMod;



// WEBPACK FOOTER //
// ./src/pages/Promote/Achievement/AchievementMod.js